import React from "react";
import { Transition } from "react-transition-group";

function BaseTransition(props) {
  const duration = 125;

  const elHeight = props.sizes ? props.sizes.height : "100%";

  //   const elHeight = props.sizes;

  const defaultStyle = {
    transition: `all ${duration}ms linear`,
    transform: "translateY(0)",
    visibility: "visible",
    height: elHeight,
    opacity: 1,
  };

  const transitionStyles = {
    entering: { opacity: 0.1, height: elHeight / 3, transform: "translateY(-50px)" },
    entered: { opacity: 1, transform: "translateY(0)", height: elHeight, visibility: "visible" },
    exiting: { opacity: 0.1, height: elHeight / 3, transform: "translateY(-50px)" },
    exited: { opacity: 0, transform: "translateY(-100px)", height: "0px", visibility: "hidden" },
  };

  return (
    <Transition in={props.in} timeout={duration}>
      {(state) => <div style={{ ...defaultStyle, ...transitionStyles[state] }}>{props.children}</div>}
    </Transition>
  );
}

export default BaseTransition;
